import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Cotización from "../components/Cotización";
// import Testimonios from "../components/Testimonios";
import Footer from "../components/Footer";
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import NavbarLogo from "../components/NavbarLogo";

export default function Services() {
    const { pathname } = useLocation();
    React.useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    const [showSpinner, setShowSpinner] = useState(true);
  
    useEffect(() => {
      const timeout = setTimeout(() => {
        setShowSpinner(false);
      }, 1);
  
      return () => clearTimeout(timeout); // Limpieza del timeout
    }, []);
    return (
        <div>
      {showSpinner && (
        <div id="spinner"  class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
          {/* Aquí puedes personalizar el spinner */}
          <div class="spinner"></div>
        </div>
      )}

   <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <a
              href="https://wa.me/+541161361408?text=¡Hola!%20Quisiera%20más%20información%20sobre%20tus%20servicios%20de%20desarrollo%20web%20y%20aplicaciones."
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i
                    className="bi bi-whatsapp me-2"
                    style={{ color: "white" }}
                  ></i>
                  +54 11 6136 1408
                </small>
              </a>
              <a
                href="tel:+541161361408"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i className="fa fa-phone-alt me-2"></i>+54 11 6136 1408
                </small>
              </a>
              <a
                href="mailto:info@elaritech.com"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="text-light">
                  <i className="fa fa-envelope-open me-2"></i>info@elaritech.com
                </small>
              </a>
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              {/*    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-twitter fw-normal"></i></a> */}
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.facebook.com/profile.php?id=61572272330417"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f fw-normal"></i>
              </a>
              {/*                     <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-linkedin-in fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-instagram fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i className="fab fa-youtube fw-normal"></i></a> */}
            </div>
          </div>
        </div>
      </div>


    <div class="container-fluid position-relative p-0">
    <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
        <NavbarLogo />
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span className="fa fa-bars"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
                <Link to="/" className="nav-item nav-link ">Inicio</Link>
                <Link to="/sobre-nosotros" className="nav-item nav-link">Sobre Nosotros</Link>
                <Link to="/nuestros-servicios" className="nav-item nav-link active">Servicios</Link>
      
                <Link to="/contáctanos" className="nav-item nav-link">Contáctanos</Link>
            </div>
            <Link
                      to="/cotización"
                      class="btn btn-primary py-2 px-4 ms-3"
                    >
                      Solicitar Cotización
                    </Link>

        </div>
        </nav>

        <div class="container-fluid bg-primary py-5 bg-services" style={{marginBottom: "90px"}}>
            <div class="row py-5">
                <div class="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 class="display-4 text-white animated zoomIn">Servicios de desarrollo web y aplicaciones</h1>
                </div>
            </div>
        </div>
    </div>


    <div class="modal fade" id="searchModal" tabindex="-1">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style={{background: "rgba(9, 30, 62, .7)"}}>
                <div class="modal-header border-0">
                    <button type="button" class="btn bg-white btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <div class="input-group" style={{maxWidth: "600px"}}>
                        <input type="text" class="form-control bg-transparent border-primary p-3" placeholder="Type search keyword"/>
                        <button class="btn btn-primary px-4"><i class="bi bi-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
    <div className="container ">
        <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
            <h5 className="fw-bold text-primary text-uppercase">Nuestros Servicios</h5>
            <h2 className="h1 mb-0">Soluciones Innovadoras por <strong style={{color: "#1976d2"}}>ELARITECH</strong></h2>
        </div>
        <div className="row g-5">
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
                <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                    <div className="service-icon">
                        <i className="fa fa-mobile-alt text-white"></i>
                    </div>
                    <h4 className="mb-3">Desarrollo de Apps</h4>
                    <p className="m-0">Creamos aplicaciones móviles personalizadas y optimizadas para tu negocio.</p>
                    
                </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                    <div className="service-icon">
                        <i className="fa fa-tv text-white"></i>
                    </div>
                    <h4 className="mb-3">Desarrollo para Smart TV</h4>
                    <p className="m-0">Desarrollamos soluciones para plataformas de TV, llevando tu contenido al siguiente nivel.</p>
                  
                </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                    <div className="service-icon">
                        <i className="fa fa-laptop-code text-white"></i>
                    </div>
                    <h4 className="mb-3">Desarrollo Web</h4>
                    <p className="m-0">Construimos sitios y plataformas web a medida con un diseño moderno y funcional.</p>
                 
                </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.3s">
                <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                    <div className="service-icon">
                        <i className="fa fa-cogs text-white"></i>
                    </div>
                    <h4 className="mb-3">Soluciones IT Personalizadas</h4>
                    <p className="m-0">Optimizamos tus procesos tecnológicos para garantizar el éxito de tu negocio.</p>
                  
                </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.6s">
                <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center">
                    <div className="service-icon">
                        <i className="fa fa-search text-white"></i>
                    </div>
                    <h4 className="mb-3">Optimización SEO</h4>
                    <p className="m-0">Posicionamos tu negocio en motores de búsqueda para llegar a más clientes.</p>
                  
                </div>
            </div>
            <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
                    <h3 className="text-white mb-3">¡Contáctanos!</h3>
                    <p className="text-white mb-3">Transforma tu idea en una realidad con nuestras soluciones tecnológicas.</p>
                    <p className="h4 text-white mb-0"><a href="tel:+541161361408" className="text-white">+54 11 6136 1408</a></p>
                </div>
            </div>
        </div>
    </div>
</div>
<Cotización/>

<div className="container-fluid py-5 bg-light">
    <div className="container py-5">
        <div className="row align-items-center">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.3s">
                <img 
                    src={require("../img/bg-slide.webp")}
                    alt="Innovación Tecnológica" 
                    className="img-fluid rounded shadow"
                />
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.6s">
                <h5 className="fw-bold text-primary text-uppercase">Innovación a Tu Alcance</h5>
                <h2 className="h1 mb-4">Impulsa Tu Negocio con Tecnología de Vanguardia</h2>
                <p className="mb-4">
                    En ELARITECH, combinamos creatividad y tecnología para ofrecerte soluciones que transforman ideas en experiencias únicas. 
                    Desde desarrollo web y apps hasta optimización SEO, llevamos tu negocio al siguiente nivel.
                </p>
            </div>
        </div>
    </div>
</div>
{/* 
<div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
<Testimonios/>
</div> */}

<Footer/>

  <ButtonWhatsapp/>
</div>
    )
}
